export type PreviewLayout = "clean" | "comparison" | "offer" | "comments" | "creator";
export interface StylePreviewAsset {
  video: string;
  poster: string;
  caption: string;
  layout: PreviewLayout;
  label?: string;
}
const preview = (id: string, caption: string, layout: PreviewLayout = "clean"): StylePreviewAsset => ({
  video: `/style-previews/v2/${id}.mp4`, poster: `/style-previews/v2/${id}.jpg`, caption, layout,
});

/** Deliberate per-style assignments, never a random test-video pool. */
export const STYLE_PREVIEWS: Record<string, StylePreviewAsset> = {
  ugc: preview("ugc_talking_head", "One person. One background. Just talking."),
  cinematic: preview("cinematic", "Luxury product close-up"),
  unboxing: preview("unboxing", "Open the box. Reveal the product."),
  review: preview("review", "Compare products side by side", "comparison"),
  promo: preview("promo", "An offer-first product ad", "offer"),
  motion: preview("motion", "Product detail. Camera movement."),
  faceless: preview("faceless", "Product-led visuals. No presenter."),
  ai_creator: preview("ai_creator", "Creator-style presentation layout", "creator"),
  clone_creator: preview("clone_creator", "Your own creator-style presentation", "creator"),
  comment_ad: preview("comment_ad", "Product with comment overlays", "comments"),
  commentary: preview("commentary", "Direct-to-camera commentary"),
  pov_unboxing: preview("pov_unboxing", "Hands-only product reveal"),
  presenter_ad: preview("presenter_ad", "Presenter introduces a product"),
  spokesperson: preview("spokesperson", "Professional brand announcement"),
  minimax_h3_product_video: preview("minimax_h3_product_video", "Visual-first product storytelling"),
  infinitetalk_avatar: preview("ugc_talking_head", "One person. One background. Just talking."),
  tpl_msvxurbx1: preview("tpl_msvxurbx1", "Gift-ready products. Seasonal offer.", "offer"),
};

export function getStylePreview(id: string): StylePreviewAsset | undefined { return STYLE_PREVIEWS[id]; }

/** Spokesperson cycles the two stock clips and the user-supplied demo. */
export function getStylePreviewPlaylist(id: string): StylePreviewAsset[] {
  const primary = getStylePreview(id);
  if (!primary) return [];
  return id === "ugc" || id === "infinitetalk_avatar"
    ? [primary, preview("spokesperson_office", primary.caption), { ...preview("spokesperson_store", primary.caption), label: "Style demo" }]
    : [primary];
}
